import React from 'react';
import PropTypes from 'prop-types';
import Notify from "../services/Notify";
import ProfileService from "../services/ProfileService";
import Loading from "../component/Loading/Loading";
import {Col, ListGroup, ListGroupItem, Row} from "react-bootstrap";

class ProfileCustomSelect extends React.Component {

  service = new ProfileService();

  constructor(props) {
    super(props);
    this.addOrRemoveProfile = this.addOrRemoveProfile.bind(this);
    this.state = {ids: props.profileIds || [], profiles: []};
    props.setValue && props.setValue(this.state.ids);
  }

  componentDidMount() {
    this.setState({loading: true});
    this.service.findAllByCompanyId(this.props.companyId).then(
      data => this.setState(
        {
          loading: false,
          profiles: data.content
        }),
      error => {
        const state = {loading: false};
        console.log('here : ' + error.response);
        if (error.response.status === 404) {
          state.message = 'Entidade não encontrada!';
        } else {
          state.message = 'Erro inesperado!';
          Notify.error('Falha o buscar entidade!', error)
        }
        this.setState(state);
      }
    )
  }

  addOrRemoveProfile(id) {
    const {setValue} = this.props;
    const position = this.state.ids.indexOf(id);
    if (position >= 0) {
      this.state.ids.splice(position, 1);
    } else {
      this.state.ids.push(id);
    }
    setValue && setValue(this.state.ids);
    this.setState({ids: this.state.ids});
  }

  render() {
    let {profiles, loading} = this.state;

    if (loading) {
      return <Loading/>
    }

    return (
      <Row>
        <Col sm={6} xs={6}>
          <ListGroup>
            {profiles.map(({id, name, role}) => {
                console.log('name', name);
                const active = (this.state.ids || []).indexOf(id) >= 0
                  ? 'active' : '';
                return <ListGroupItem href="#" onClick={(e) => {
                  this.addOrRemoveProfile(id);
                  e.preventDefault();
                }} key={id} active={active}>
                  <h5>{name}</h5>
                </ListGroupItem>
              }
            )}
          </ListGroup>
        </Col>
      </Row>);
  }
}

ProfileCustomSelect.propTypes = {
  profileIds: PropTypes.array,
  history: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default ProfileCustomSelect;




// WEBPACK FOOTER //
// ./src/profile/ProfileCustomSelect.js